import { useCallback } from 'react';
import { notification, Modal } from 'antd';
import { useCheckDesksBusyMutation } from '../../api/checkDesksBusyInCurrentAcceptance';
import { checkDesksBusyCodes } from '../../shared/configs/checkDesksBusyCodes';

export const useCheckDesksBusyWithCb = () => {
  const { mutate, isLoading } = useCheckDesksBusyMutation();

  const check = useCallback(
    async ({ fromDate, toDate, desks }, fn) => {
      mutate(
        { fromDate, toDate, desks },
        {
          onSuccess: (data) => {
            if (!data || data === 'Error') return;
            const cb = createCheckCallback({ fn, desksLength: desks.length });
            cb(data);
          },
        }
      );
    },
    [mutate]
  );

  return { check, isLoading };
};

function createCheckCallback({ fn, desksLength }) {
  return (data = {}) => {
    const { code, message, countDesks } = data;

    switch (code) {
      case checkDesksBusyCodes.notBusy: {
        countDesks === desksLength
          ? notification.error({
              message: 'Ошибка',
              description:
                'Ни один из столов не задействован в выбранные дни. Добавьте в настроки столов дни, которые будут находится в указанном периоде',
              placement: 'topLeft',
            })
          : Modal.confirm({
              title: 'Внимание',
              content: message,
              centered: true,
              onOk: () => {
                fn();
              },
              onCancel: () => {},
            });

        return;
      }

      default: {
        fn();
      }
    }
  };
}
